import React, { useState } from 'react'
import '../style/TableOrderDetails.scss'
import t from 'counterpart'

const TableOrderDetails = () => {
    const [ActiveTransactionInfo, setActiveTransactionInfo] = useState(false)
    return (
        <div className="table__details">
            <h6 className="mt-2 mx-auto">{t('Your payment was successful!')}</h6>

            <div className="table__card">
                <span className="table__card--number">{t("Table")} 1</span>
                <span className="table__card--type">{t('Partially paid')}</span>
            </div>

            <div className={`trnsaction__info ${ActiveTransactionInfo ? 'active' : ''}`}>
                <div
                    className="trnsaction__info__label"
                    onClick={() => setActiveTransactionInfo(!ActiveTransactionInfo)}
                >
                    <h6 className="mb-2 fw-bold">
                        {t('You paid')} 20 {t('SAR')} {t('for your table')}
                    </h6>
                    <i
                        class={`fa-solid ${ActiveTransactionInfo ? 'fa-chevron-up' : 'fa-chevron-down'}`}
                    ></i>
                </div>
                <div className="trnsaction__info__content">
                    <span className="content__label"> {t('Transaction info')} </span>

                    <p className='left_to_pay'>
                        20 {t('SAR')} {t('is left to pay')}
                    </p>
                </div>
            </div>

            <div className="table__feadback">
                <h6>{t('How was your dining experiance')}</h6>
                <a className="google__location" href="#">
                    <img
                        src="https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA"
                        alt="google_logo"
                    />
                    <small>{t('Review this place on google')}</small>
                </a>
            </div>
        </div>
    )
}

export default TableOrderDetails
